import { DiningOption } from '@features/DynamicPackagesConfigurationWizard/types';
import { TimeSlotsType } from '@features/tables/schemas/TablesAvailability.schema';
import { some } from '@utils/some';

export const filterTimeslotsByMenuOrTimeRestriction = (
  timeslots: TimeSlotsType,
  currentStep: DiningOption
) => {
  const filteredTimeSlotsByMenu = some(currentStep.menuIds)
    ? timeslots.filter((ts) => {
        const promotionIds = (ts?.availablePromotions || []).map((promo) => String(promo.id));
        return (currentStep?.menuIds || []).some((item) => promotionIds.includes(String(item)));
      })
    : timeslots;

  return !!currentStep.timeslotRestrictions
    ? filteredTimeSlotsByMenu.filter((timeslot) => {
        if (
          !!currentStep.timeslotRestrictions?.startTime &&
          !!currentStep.timeslotRestrictions.endTime
        ) {
          const timeslotStart = new Date(timeslot.timeSlot).toLocaleTimeString([], {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
          return (
            timeslotStart >= currentStep.timeslotRestrictions.startTime &&
            timeslotStart <= currentStep.timeslotRestrictions.endTime
          );
        } else {
          return true;
        }
      })
    : filteredTimeSlotsByMenu;
};
